/**
 * Investor Type Enum
 * Used for registration type field
 */
export enum InvestorType {
  INDIVIDUAL = 1,
  CORPORATE = 2,
}
